import { set } from 'lodash';
import { unwrap as buildResponseTransformation } from '../common';
const buildRequestTransformation = ({ requestMessageEntityPath }) => set({}, requestMessageEntityPath, '$[0]');
export { buildRequestTransformation, buildResponseTransformation };
//# sourceMappingURL=create.js.map